import { render, staticRenderFns } from "./StatusPanelorder.vue?vue&type=template&id=23968e84&scoped=true"
import script from "./StatusPanelorder.vue?vue&type=script&lang=ts"
export * from "./StatusPanelorder.vue?vue&type=script&lang=ts"
import style0 from "./StatusPanelorder.vue?vue&type=style&index=0&id=23968e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23968e84",
  null
  
)

export default component.exports